export const MAX_WIDTH = 512;

export const FOOTER_HEIGHT = 80;
